const aaa = [
	
	{
		path: "fileStatistics",
		component: () => import("@/views/file/fileStatistics.vue"),
		meta:{title:'全部文件'},
	}
]
export default aaa;